import { Flex, Grid, Skeleton } from '@chakra-ui/react'
import React, { useEffect } from 'react'

import { CustomWaypoint } from '@/components/CustomWaypoint'
import { Loading } from '@/components/Loading'
import { Recap } from '@/components/Recap'
import { RecapSummaryHeader } from '@/components/RecapSummary/RecapSummaryHeader'
import { useSelectedOffersAddonContext } from '@/context/SelectedOffersAddonProvider'
import { useSidebar } from '@/context/SidebarContext'
import type { PageSection } from '@/layouts/components/Sidebar'

import { ExtraInsuranceInformation } from './forms/ExtraInsuranceInformation'

export const StepComplete = () => {
  const { addonOffers, isLoadingData } = useSelectedOffersAddonContext()
  const { setPageSections, pageSections } = useSidebar()

  // registrace sekcí
  useEffect(() => {
    const array: PageSection[] = []
    let i = 1

    // animace nacitani doplnkovych pripojisteni
    if (isLoadingData) {
      array.push({
        id: 'extraInsuranceLoading',
        sectionTitle: 'Doplňková připojištění...',
        isDisabled: true,
        index: i,
        children: (
          <CustomWaypoint
            sectionId="extraInsuranceLoading"
            cardProps={{ sx: { gap: 16, pb: 16 } }}
          >
            <Recap id="extraInsuranceLoading" sx={{ gap: 16, pb: 16 }}>
              <RecapSummaryHeader number={i}>
                <Flex>
                  <Skeleton isLoaded={false}>Doplňková připojištění</Skeleton>
                </Flex>
              </RecapSummaryHeader>
              <Loading />
            </Recap>
          </CustomWaypoint>
        ),
      })
      i++
    }
    // vypis vsech doplnkovych pripojisteni (offers)
    else if (addonOffers && addonOffers.length > 0) {
      addonOffers
        .filter(x => x.valid)
        .sort((a, b) => a.insurerId - b.insurerId)
        .forEach((x) => {
          array.push({
            id: x.offerId,
            sectionTitle: x.name,
            index: i,
            children: (
              <CustomWaypoint
                key={x.offerId}
                sectionId={x.offerId}
                cardProps={{ sx: { gap: 16, pb: 16 } }}
              >
                <Recap id={x.offerId.toString()} sx={{ gap: 16, pb: 16 }}>
                  <ExtraInsuranceInformation
                    offer={x}
                    sectionTitle={x.name ?? x.riskVariantName}
                    sectionNumber={i}
                  />
                </Recap>
              </CustomWaypoint>
            ),
          })
          i++
        })
    }

    setPageSections(array)
  }, [isLoadingData, addonOffers])

  return (
    <Grid sx={{ gap: 8 }}>
      {pageSections &&
        pageSections.map((x) => (
          <React.Fragment key={x.id}>{x.children}</React.Fragment>
        ))}
    </Grid>
  )
}
